import { reactive } from 'vue'

// Not org- or application-scoped on purpose: this is a personal UI preference
// (which sections a user likes collapsed), so it's stored under one shared
// key and applies to every application factsheet the user opens.
const STORAGE_KEY = 'applicationFactsheetCollapsedSections'

export const SECTION_KEYS = ['information', 'dependencies', 'companies_departments']

function loadFromStorage() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    const parsed = raw ? JSON.parse(raw) : {}
    return parsed && typeof parsed === 'object' ? parsed : {}
  } catch {
    return {}
  }
}

function persist() {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(collapsed))
  } catch {
    // Storage unavailable (private browsing, quota) — preference just won't persist.
  }
}

// Module-level (not created inside the function below), so every component
// that calls useApplicationFactsheetSections() shares the same reactive state —
// this is what lets the header's "Collapse all" toggle affect every section,
// and every section stay in sync with each other and with localStorage.
const collapsed = reactive(loadFromStorage())

export function useApplicationFactsheetSections() {
  function isCollapsed(key) {
    return !!collapsed[key]
  }

  function allCollapsed() {
    return SECTION_KEYS.every((key) => collapsed[key])
  }

  function toggleSection(key) {
    collapsed[key] = !collapsed[key]
    persist()
  }

  function expandSection(key) {
    if (!collapsed[key]) return
    collapsed[key] = false
    persist()
  }

  function toggleAll() {
    const nextValue = !allCollapsed()
    SECTION_KEYS.forEach((key) => { collapsed[key] = nextValue })
    persist()
  }

  return { isCollapsed, allCollapsed, toggleSection, expandSection, toggleAll }
}
